/* Tribal Wellness — theme interactions */
(function () {
  'use strict';

  /* ---------- Mobile nav drawer ---------- */
  function initMobileNav() {
    document.querySelectorAll('[data-hamburger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-target'));
        if (target) target.classList.toggle('open');
      });
    });
  }

  /* ---------- Hero slider (per-section, supports multiple) ---------- */
  function initHero(root) {
    var slides = root.querySelectorAll('.slide');
    var dots = root.querySelectorAll('.dot');
    if (slides.length <= 1) {
      if (slides.length === 1) slides[0].classList.add('active');
      return;
    }
    var cur = 0, timer = null;
    var delay = parseInt(root.getAttribute('data-interval'), 10) || 5000;

    function show(i) {
      slides.forEach(function (s) { s.classList.remove('active'); });
      dots.forEach(function (d) { d.classList.remove('active'); });
      slides[i].classList.add('active');
      if (dots[i]) dots[i].classList.add('active');
      cur = i;
    }
    function next() { show((cur + 1) % slides.length); }
    function reset() { clearInterval(timer); timer = setInterval(next, delay); }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); reset(); });
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', reset);

    show(0);
    reset();
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14 });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    initMobileNav();
    document.querySelectorAll('[data-hero]').forEach(initHero);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-init when a section is added/reloaded in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-hero]');
    if (hero) initHero(hero);
    initMobileNav();
    initReveal();
  });
})();
